import React from "react";
import { FiSearch } from "react-icons/fi";
import { FormGroup, FormControl } from "react-bootstrap";
import Avatar from "components/Avatar";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";

class NotificationLikesModal extends React.Component {
	state = { q: "" };
	handleSearch = (e) => this.setState({ q: e.target.value });
	getFullName = (u) => `${u?.name || ""} ${u?.surname || ""}`.trim();

	render() {
		const noti = (this.props.notifications || []).find(
			(n) => n.id === this.props.notificationId
		);
		const likedBy = noti?.liked_by || [];

		const q = this.state.q.trim().toLowerCase();
		const filtered = likedBy.filter((u) =>
			this.getFullName(u).toLowerCase().includes(q)
		);

		return (
			<div className="modal-body modal-likes">
				<FormGroup className="form-group form-search" controlId="q">
					<FormControl
						type="text"
						placeholder="Buscar..."
						value={this.state.q}
						onChange={this.handleSearch}
						autoComplete="off"
					/>
					<FiSearch />
				</FormGroup>

				<ul className="likes-list">
					{filtered.map((employee) => (
						<li key={employee.id} className="likes-item">
							<Avatar
								userId={employee.id}
								className="avatar-xs"
								alt={employee.name}
							/>
							<EmployeeLink
								employee={employee}
								className="likes-name"
								title={this.getFullName(employee)}
							>
								{this.getFullName(employee)}
							</EmployeeLink>
						</li>
					))}

					{filtered.length === 0 && (
						<li className="likes-empty">No hay resultados</li>
					)}
				</ul>
			</div>
		);
	}
}

export default NotificationLikesModal;
